module.exports = __webpack_public_path__ + "videos/mts-products-comdi.ef6f23b.mp4";